import { Navigate, useOutlet } from "react-router-dom";

export const AuthProtectedLayout = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const outlet = useOutlet();

  if (userData) {
    return <Navigate to="/home" />;
  }

  return <div>{outlet}</div>;
};
